"use client";

import { AvatarOsoby } from "./avatar-osoby";
import { AvatarData } from "@/lib/avatar-utils";

interface PlayerAvatarProps {
  hracId: string;
  meno: string;
  pozicia?: string;
  avatarUrl?: string | null;
  avatarVerzia?: number;
  className?: string;
  fallbackClassName?: string;
}

export function PlayerAvatar({
  hracId,
  meno,
  pozicia,
  avatarUrl,
  avatarVerzia,
  className,
  fallbackClassName,
}: PlayerAvatarProps) {
  const avatarData: AvatarData = {
    avatar_url: avatarUrl || null,
    avatar_verzia: avatarVerzia || 0,
  };

  return (
    <AvatarOsoby
      typ="hrac"
      id={hracId}
      meno={meno}
      avatarData={avatarData}
      pozicia={pozicia}
      className={className}
      fallbackClassName={fallbackClassName}
    />
  );
}
